function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (Math, earned, i18n, max, parentKlass, stars) {
      var parentKlass, max = 9;
if (stars.length < 2)      parentKlass = "text-xl";
else if (stars.length < 6) parentKlass = "text-lg";
else if (stars.length < 8) parentKlass = "text-md";
else { parentKlass = "text-sm"; };
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["text-nowrap",parentKlass], [false,true]), false, true)) + "\u003E";
// iterate stars.slice(0, max)
;(function(){
  var $$obj = stars.slice(0, max);
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var star = $$obj[i];
if (!star) star = {};
var klass = "delay-" + Math.min(i, 10);
if (star.complete) klass += " active";
if (stars.length > 6) klass += " bunched";
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["star",klass], [false,true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var star = $$obj[i];
if (!star) star = {};
var klass = "delay-" + Math.min(i, 10);
if (star.complete) klass += " active";
if (stars.length > 6) klass += " bunched";
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["star",klass], [false,true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Ch4 class=\"text-bold text-nowrap\"\u003E ";
var earned = _.where(stars, { complete: true }).length
pug_html = pug_html + (pug_escape(null == (pug_interp = i18n("stars.earned", { earned: earned, smart_count: stars.length })) ? "" : pug_interp)) + "\u003C\u002Fh4\u003E";
    }.call(this, "Math" in locals_for_with ?
        locals_for_with.Math :
        typeof Math !== 'undefined' ? Math : undefined, "earned" in locals_for_with ?
        locals_for_with.earned :
        typeof earned !== 'undefined' ? earned : undefined, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "max" in locals_for_with ?
        locals_for_with.max :
        typeof max !== 'undefined' ? max : undefined, "parentKlass" in locals_for_with ?
        locals_for_with.parentKlass :
        typeof parentKlass !== 'undefined' ? parentKlass : undefined, "stars" in locals_for_with ?
        locals_for_with.stars :
        typeof stars !== 'undefined' ? stars : undefined));
    ;;return pug_html;};module.exports=template;